import React from "react";

import { chartColors } from "../../../config/colors";

interface FooterProps {
  text: string;
  link?: string;
  scalingFactor?: number;
  transform?: string;
  alignRight?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  text,
  link,
  scalingFactor = 1,
  transform = "",
  alignRight = false,
}) => {
  return (
    <g className="footer" transform={transform}>
      <a href={link} target="_blank" rel="noopener" role="link">
        <text
          fontSize={12 * scalingFactor}
          textAnchor={alignRight ? "end" : "start"}
          fill={chartColors.fontSecondary}
          style={{ fill: chartColors.fontSecondary }}
        >
          {text}
        </text>
      </a>
    </g>
  );
};
